<template>
  <SplitViewTemplate
    :screenConfig="setScreenConfig"
    :backButtonRoute="'/settings/production'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
  />
</template>

<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";

import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import { FeatureStorage } from "../../../_services/storage";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      formModel: {
        Inactive: false,
        ShortCode: null,
        Name: null,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Exception Reasons",
        pageRoute: "/exception-reasons",
        saveEndPoint: "ShiftExceptionReason",
        recordEndPoint: "ShiftExceptionReason",
        updateEndPoint: "ShiftExceptionReason",
        updateKeyField: "RecordId",
        updateKeyFieldType: "Guid",
        isDefaultEndPoint: undefined,
        recordPostProcess: undefined,
        exportFileName: "Exception Reasons List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "ShiftExceptionReasonList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "exception-reasons",
              mode: "review",
              idMode: "Guid",
              idProperty: "RecordId",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/exception-reasons/create",
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "ProductionSettings",
                  "create",
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "Code",
              label: "Short Code",
              dataField: "ShortCode",
              sortOrder: "asc",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              filterIndex: 0,
              filterLabel: "Reason",
              type: "Text",
              filterDataField: "SearchText",
              width: ColumnWidth.Code.width + 10, // added 10 to avoid cutting text
              maxWidth: ColumnWidth.Code.minWidth + 10,
            },
            {
              screenField: "Name",
              dataField: "Name",
              label: "Name",
              minWidth: ColumnWidth.Description.minWidth,
            },

            {
              screenField: "DateCreated",
              label: "Date Created",
              filterLabel: "Date Created",
              width: ColumnWidth.Date.width,
              maxWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "CreatedBy",
              width: ColumnWidth.CreatedBy.width,
              minWidth: ColumnWidth.CreatedBy.minWidth,
            },
            {
              screenField: "Date",
              dataField: "DateChanged",
              label: "Date Changed",
              width: ColumnWidth.Date.width,
              maxWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "ChangedBy",
              width: ColumnWidth.CreatedBy.width,
              minWidth: ColumnWidth.CreatedBy.minWidth,
            },

            {
              screenField: "Status",
              // filterDataField: "FriendlyInactive",
              filterIndex: 1,
            },
          ],
        },
      };

      return config;
    },

    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          audit: true,
          save: FeatureStorage.checkPermission("ProductionSettings", "create"),
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
              },
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "ShortCode",
                required: true,
                screenField: "Code",
                label: { text: "Short Code" },
                editorOptions: {
                  maxLength: 10,
                },
              },
              {
                dataField: "Name",
                required: true,
                screenField: "Name",
                editorOptions: {
                  maxLength: 100,
                },
              },
            ],
          },
        ],
        overWritePayload: undefined,
        formHeight: "90px",
      };

      return form;
    },
    setActiveReadOnly() {
      return this.formModel["SetDefault"] ? true : false;
    },
  },
  methods: {},
};
</script>
